import { DEFAULT_LOCALE, isSupportedLocale } from "../i18n/locales.js";
import { TODO_TRANSLATE } from "./i18nField.js";
import { normalizeDisplayText } from "./textNormalization.js";

const articleSeoProfiles = {
  "divine-synthesis": {
    section: "Spiritual Philosophy",
    description: {
      en: "Explore Divine Synthesis as a reflection on the many expressions of the Divine returning to unity, consciousness, and the Great Work."
    },
    tags: ["Unity", "Divine Consciousness", "Spiritual Philosophy", "Mysticism", "Hermeticism", "The Great Work", "Natural Law"]
  },
  "universal-base-directives-the-three-pillars": {
    section: "Universal Law",
    description: {
      en: "Explore Universal Base Directives through the three pillars of Unity, Freedom, and Adaptation as a mystical reflection on sentient life, consciousness, and cosmic law."
    },
    tags: ["Universal Law", "Unity", "Freedom", "Adaptation", "Ethics", "Consciousness", "The Great Work", "Spiritual Philosophy"]
  },
  "to-live-is-to-die-to-die-is-to-be-reborn": {
    section: "Initiation",
    description: {
      en: "Enter an alchemical meditation on death, rebirth, Divinity, and the inner work required to decipher transformation through lived initiation."
    },
    tags: ["Alchemy", "Initiation", "Rebirth", "Mysticism", "Inner Development", "Spiritual Philosophy", "The Great Work"]
  },
  mjolnir: {
    section: "Symbolism",
    description: {
      en: "Study Mjölnir as a symbol of truth, protection, and sacred force within the TGWE logo and the wider language of ancient wisdom."
    },
    tags: ["Symbolism", "Norse Mythology", "Truth", "Protection", "Ancient Wisdom", "The Great Work", "Occult Philosophy"]
  },
  "the-case-for-graven-and-molten-images": {
    section: "Symbolism",
    description: {
      en: "Examine graven and molten images through sacred symbolism, religious interpretation, and the deeper purpose of image, form, and representation."
    },
    tags: ["Symbolism", "Sacred Images", "Comparative Religion", "Ancient Wisdom", "Occult Philosophy", "Ethics", "Spiritual Philosophy"]
  },
  "the-electric-logos": {
    section: "Cosmology",
    description: {
      en: "Explore the Electric Logos through ancient cosmology, the electric universe, Kabbalah, consciousness, and the symbolic current of creation."
    },
    tags: ["Electric Universe", "Logos", "Kabbalah", "Consciousness", "Symbolism", "Hermeticism", "Natural Law", "Spiritual Philosophy"]
  },
  "liber-555": {
    section: "Freedom",
    description: {
      en: "Read Liber 555: Transitus ad Libertatem as a manifesto for freedom, natural law, responsibility, and the restoration of self-mastery."
    },
    tags: ["Freedom", "Natural Law", "Ethics", "Self-Mastery", "The Great Work", "Spiritual Philosophy", "Human Potential"]
  },
  "the-sacred-gift-of-beauty": {
    section: "Occult Philosophy",
    description: {
      en: "Reflect on beauty as a sacred gift connected with mercy, judgment, occult philosophy, and the harmonizing work of inner development."
    },
    tags: ["Beauty", "Mercy", "Judgment", "Kabbalah", "Occult Philosophy", "Inner Development", "Spiritual Philosophy"]
  },
  "sample-monograph-the-neteru": {
    section: "Egyptian Mysticism",
    description: {
      en: "Begin the monograph series through the Neteru, Ma’at, Tehuti, and the Egyptian understanding of divine forces, natural law, and cosmic order."
    },
    tags: ["Egyptian Mysticism", "Neteru", "Ma’at", "Ancient Wisdom", "Esoteric Education", "Initiation", "Symbolism"]
  },
  "the-codex-of-eternity-from-the-djd-waw-the-first-speech": {
    section: "Tarot",
    description: {
      en: "Enter the Codex of Eternity as the first speech of the Tarot path, presenting initiation, transformation, and the ascent of the soul."
    },
    tags: ["Tarot", "Initiation", "Ancient Wisdom", "Esoteric Education", "Inner Development", "The Great Work", "Mysticism"]
  },
  "understanding-law-there-are-no-human-laws-only-eternal-principles-governing-reality": {
    section: "Natural Law",
    description: {
      en: "Study law as eternal principle rather than human decree, with consequence, alignment, and responsibility as foundations of reality."
    },
    tags: ["Natural Law", "Universal Law", "Ethics", "Freedom", "Consequence", "Spiritual Philosophy", "The Great Work"]
  },
  "freedom-the-divine-elixir-of-harmony": {
    section: "Freedom",
    description: {
      en: "Consider freedom as the divine elixir of harmony, rooted in natural law, ethical conduct, and right relation with the Earth."
    },
    tags: ["Freedom", "Harmony", "Natural Law", "Ethics", "Universal Law", "The Great Work", "Spiritual Philosophy"]
  },
  "lord-of-the-elements-son-of-the-sun": {
    section: "Hermeticism",
    description: {
      en: "Explore the four elements, solar symbolism, and the source of power through Western and Eastern esoteric patterns of inner mastery."
    },
    tags: ["Four Elements", "Solar Symbolism", "Hermeticism", "Occult Philosophy", "Inner Development", "Ancient Wisdom"]
  },
  "the-suppression-of-the-divine-feminine-force": {
    section: "Spiritual Philosophy",
    description: {
      en: "Examine the Divine Feminine Force through ethics, consciousness, and a distinction between true feminine principle and modern distortion."
    },
    tags: ["Divine Feminine", "Ethics", "Spiritual Philosophy", "Inner Development", "Consciousness", "Natural Law"]
  },
  "on-the-purpose-of-humanity-on-earth": {
    section: "Human Purpose",
    description: {
      en: "Reflect on humanity’s purpose on Earth through Creation, Providence, conscious responsibility, and the wise contemplation of human potential."
    },
    tags: ["Human Purpose", "Creation", "Providence", "Human Potential", "Spiritual Philosophy", "The Great Work", "Consciousness"]
  },
  "the-states-of-consciousness-in-the-evolution-of-men": {
    section: "Consciousness",
    description: {
      en: "Study the seven states of consciousness and conscious evolution as a path of self-mastery, human development, and initiatic education."
    },
    tags: ["Consciousness", "Evolution", "Self-Mastery", "Human Potential", "Inner Development", "Esoteric Education", "The Great Work"]
  },
  "a-small-discourse-on-the-immutability-of-natural-laws": {
    section: "Natural Law",
    description: {
      en: "Contemplate the immutability of natural laws, divine order, cycles of experience, and the rules through which reality is structured."
    },
    tags: ["Natural Law", "Universal Law", "Divine Order", "Cycles", "Ethics", "Spiritual Philosophy", "Ma’at"]
  },
  "on-the-purpose-of-humanity-in-the-universe": {
    section: "Human Purpose",
    description: {
      en: "Explore humanity’s purpose in the universe through biblical parallels, ancient accounts, Zecharia Sitchin, and the larger question of human destiny."
    },
    tags: ["Human Purpose", "Comparative Religion", "Mythology", "Ancient Accounts", "Human Potential", "Spiritual Philosophy", "Consciousness"]
  }
};

function safeLocale(lang) {
  return isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;
}

function clean(value, options) {
  return normalizeDisplayText(value, options);
}

export function localizedArticleField(field, lang = DEFAULT_LOCALE, options = {}) {
  const locale = safeLocale(lang);

  if (typeof field === "string") return clean(field, options);
  if (!field || typeof field !== "object") return "";

  const candidates = [field[locale], field[DEFAULT_LOCALE], ...Object.values(field)];
  const value = candidates.find((entry) => entry && entry !== TODO_TRANSLATE);
  return value ? clean(value, options) : "";
}

export function getArticleTitle(article, lang = DEFAULT_LOCALE) {
  return localizedArticleField(article?.title, lang);
}

export function getArticleDescription(article, lang = DEFAULT_LOCALE) {
  const profile = articleSeoProfiles[article?.id];
  return localizedArticleField(profile?.description || article?.summary, lang, { stripMarkdown: true });
}

export function getArticleExcerpt(article, lang = DEFAULT_LOCALE) {
  return localizedArticleField(article?.summary, lang, { stripMarkdown: true }) || getArticleDescription(article, lang);
}

export function getArticleSection(article) {
  return articleSeoProfiles[article?.id]?.section || "Articles";
}

export function getArticleTags(article) {
  const semanticTags = articleSeoProfiles[article?.id]?.tags || [];
  return [...new Set(semanticTags.map((tag) => clean(tag)).filter(Boolean))];
}

export function getArticleImageAlt(article, lang = DEFAULT_LOCALE) {
  const title = getArticleTitle(article, lang);
  const section = getArticleSection(article);
  return title ? `${title} article image for ${section}` : localizedArticleField(article?.imageAlt, lang);
}
